/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React from 'react';

export const AppContext = React.createContext({});

export const AppContextProvider = ({ value, children }) => (
  <AppContext.Provider value={value}>
    {children}
  </AppContext.Provider>
);
